/**
 * `wa.me` accepts digits only — no `+`, spaces, slashes or dashes — and needs
 * the country code. Editors type the number the way it reads on a page
 * ("+49 170 1234567"), so the displayed form and the link form differ on
 * purpose: this strips everything that is not a digit.
 *
 * A leading `00` is the other way of writing `+`, so it collapses to nothing
 * rather than travelling into the link as two digits of a wrong country code.
 */
export function toWhatsappLink(phoneNumber: string): string | null {
  const digits = phoneNumber.replace(/\D/g, '').replace(/^00/, '');
  // A handful of digits is a typo, not a number; linking it would open a chat
  // with whoever that resolves to.
  return digits.length >= 8 ? `https://wa.me/${digits}` : null;
}
